export const stopPropagation = (e) => {
  e.stopPropagation();
};
